import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { OrderCardDto, UserFormsServiceProxy } from '../../../../../../../shared/service-proxies/service-proxies';
import { OrderService } from '../../services/order-service';
import { Router, ActivatedRoute, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { TestService } from '../../../../../../../test/service/test.service';
import { document } from 'ngx-bootstrap';
import { CarsDb } from '@app/core/_base/layout/server/fake-api/fake-db/cars';
import { CustomLocalizationService } from '../../../utility/customLocalization.service';

@Component({
  selector: 'kt-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss'],
  
})
export class Step1Component implements OnInit, OnDestroy {

	cards = new BehaviorSubject<OrderCardDto[]>([]);
	//butonlarda spinner görünğr ya da gizli yapmak için kullanılır.
	loading = new BehaviorSubject<boolean>(false);

	orderItemSubscribe: Subscription;

	isOrderTypeNotFound = new BehaviorSubject<boolean>(false);

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private _userFormService: UserFormsServiceProxy,

		private _testService: TestService,
		private orderService: OrderService,
		private customLocalization: CustomLocalizationService

	) {

	
  }

	ngOnInit() {

		this.isOrderTypeNotFound.next(false);	

		this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.HEADER"));
		this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.SUBHEADER"));


		this._userFormService.getMainOrderCardsByUserForms()
			.subscribe(result => {
				console.log("step1 sayfasındayım");

				
				//görme yetkisi olanları al diyoruz.
				result = result.filter(x => x.isVisible == true);

				if(result.length < 1){
					this.isOrderTypeNotFound.next(true);	
				}
				
				this.cards.next(result);

			});
	}

	btnOrder(cardId : number){

		this.orderService.cardId.next(cardId);

		//Cardların üzerinde yazan açıklamaları bir sonraki sayfada yakalamak için kullanıyoruz.
		//var cardObj = this.cards.getValue().find(x => x.id == cardId);

		//if(cardObj){
		//	this.orderService.cardTitleAndSubTitleStep2.next({title: cardObj.title , subTitle: cardObj.subTitle })

		//}
		//console.log("Step1 Navigate");

		this.router.navigate(['../step2/', cardId], { relativeTo: this.route });

	}

  ngOnDestroy() {
	  this.cards.unsubscribe();
	  this._testService.setTitle(" ");
	  this._testService.setDesc(" ");
  }
}
